import AttachFileOutlinedIcon from '@material-ui/icons/AttachFileOutlined';
import {
    Backdrop, Card, CardContent, CircularProgress, Grid, CardHeader, Box, Tooltip,
    Typography, ListItem, IconButton, DialogActions, ListItemSecondaryAction, Select, FormControl
} from '@material-ui/core';
import Alert from 'src/components/Alert';
import CloseIcon from '@material-ui/icons/Close';
import Badge from '@material-ui/core/Badge';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Dropzone from 'react-dropzone-uploader';
import 'react-dropzone-uploader/dist/styles.css';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import axios from 'src/utils/axios';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import List from '@material-ui/core/List';
import ListItemText from '@material-ui/core/ListItemText';
import Snackbar from '@material-ui/core/Snackbar';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/styles';
import { DataGrid } from '@material-ui/data-grid';
import React, { useEffect } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import DeleteIcon from '@material-ui/icons/Delete';
import VisibilityIcon from '@material-ui/icons/Visibility';
import 'src/assets/css/confirmOverlay.css';
const useStyles = makeStyles((theme) => ({
    root: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
    },
    backdrop: {
        zIndex: 1500,
        color: '#fff'
    },
    confirmOverlay: {
        zIndex: 9999 + ' !important'
    }
}));



function Overview(props) {
    const classes = useStyles();
    const { basvuruId, documentType, dosyaAdet, documentTypeNumber, openClose } = props;
    const [uyari, setUyari] = React.useState(false);
    const [loading, setLoading] = React.useState(false)
    const [searchName, setSearchName] = React.useState('')
    const [fileTypeData, setFileTypeData] = React.useState([])
    const [selectedUser, setSelectedUser] = React.useState(-1)
    const [rows, setRows] = React.useState([])
    const [tailUsers, setTailUsers] = React.useState([])
    const [transferTo, setTransferTo] = React.useState('')
    const [selectedTail, setSelectedTail] = React.useState([]);
    const [transferDialogOpen, setTransferDialogOpen] = React.useState(false);
    const [uploadFilePopUp, setUploadFilePopUp] = React.useState(false);
    const [uyariTip, setUyariTip] = React.useState(false);
    const [fileType, setFileType] = React.useState(0);
    const [uyariAciklama, setUyariAciklama] = React.useState('')
    const [deleteFile, setDeleteFile] = React.useState([])
    const [oneFile, setOneFile] = React.useState([])

    const [responseMessage, setresponseMessage] = React.useState({
        ErrorCode: '0',
        ErrorDescription: ('success_message')
    });



    useEffect(() => {
        if (!basvuruId) {
            return;
        }
        getReceiptFiles(basvuruId);
    }, [props.basvuruId, props.dosyaAdet]);





    function uploadFiles(filedata) {
        axios.post("/UploadFile", filedata, {
            headers: { 'Content-Type': 'application/json' }
        }).then(response => {
            getReceiptFiles(basvuruId);
            setFileType(null);
            setUyari(true);
            setUyariAciklama("İşleminiz başarı ile gerçekleşti.")
            setUyariTip("success")
        });
    }

    const getReceiptFiles = (basvuruId) => {
        setLoading(true)
        if (!basvuruId) {
            return;
        }
        axios.get("/GetReceiptFiles/" + basvuruId + '/' + 1 + '/' + documentTypeNumber, {
            responseType: 'arrayBuffer'
        }).then(response => {
            const res = response.data;
            if (!res) {
                setLoading(false)
                setRows([])
            }
            else {
                setRows(res)
                setLoading(false)
            }
        });
    }
    const getReceiptFilesSpecial = (id) => {
        setLoading(true)
        var images = []
        axios.get("/getReceiptFilesSpecial/" + id, {
            responseType: 'arrayBuffer'
        }).then(response => {
            setOneFile(response.data)
            setLoading(false)
        });
    }

    const handleUserClick = () => {
        getReceiptFiles(basvuruId);
    }


    const setNewWindowOpen = (id) => {
        setLoading(true);
        axios.get("/getReceiptFilesSpecial/" + id, {
            responseType: 'arrayBuffer'
        }).then(response => {
            setLoading(false);
            const res = response.data[0]
            if (!res) {
                return;
            } else {
                var FileData = `data:${res.DOSYA_TIPI};base64,${res.DOSYA_DATA}`
                if (res?.DOSYA_TIPI?.includes('image')) {
                    var image = new Image();
                    image.src = FileData;
                    var w = window.open("");
                    w.document.write(image.outerHTML);
                    w.document.title = res.DOSYA_ADI;
                    w.document.close();
                } else {
                    var blobData = base64ToBlob(res.DOSYA_DATA, "application/pdf");
                    openBlobInNewTab(blobData);
                }
            }
        });
    }

    function base64ToBlob(base64Data, contentType) {
        var byteCharacters = atob(base64Data);
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: contentType });
    }
    function openBlobInNewTab(blobData) {
        var newTab = window.open();
        var objectUrl = URL.createObjectURL(blobData);
        newTab.document.write('<embed width="100%" height="100%" src="' + objectUrl + '" type="application/pdf"></embed>');
    }

    const columns = [
        { field: 'DOSYA_ADI', headerName: 'Dosya Türü ve Adı', width: 300 },
        {
            field: 'Göster',
            renderCell: (cellValues) => {
                return (
                    <Box sx={{ justifyContent: 'center', "& > :not(style)": { m: 1 } }}>
                        <Tooltip title="Göster">
                            <IconButton
                                onClick={() => {
                                    setNewWindowOpen(cellValues.row.id)
                                }}
                            >
                                <VisibilityIcon color='primary' />
                            </IconButton>
                        </Tooltip>
                    </Box>
                );
            }, width: 150
        },
        {
            field: 'Sil',
            renderCell: (cellValues) => {
                return (
                    <Box sx={{ justifyContent: 'center', "& > :not(style)": { m: 1 } }}>
                        <Tooltip title="Sil">
                            <IconButton
                                onClick={() => { handleDeleteSureClick(cellValues.row.id) }}
                            >
                                <DeleteIcon color='primary' />
                            </IconButton>
                        </Tooltip>
                    </Box>
                );
            }, width: 150
        }
    ];

    const handleDeleteSureClick = (fileId) => {
        confirmAlert({
            message: ('Silmek istediğinizden emin misiniz?'),
            buttons: [
                {
                    label: ('Evet'),
                    onClick: () => handleDeleteClick(fileId)
                },
                {
                    label: ('Hayır'),
                    onClick: () => { }
                }
            ],
            overlayClassName: "confirmOverlay"
        });
    }

    const handleDeleteClick = (fileId) => {
        setLoading(true);
        axios.get("/DeleteFile/" + fileId, {
            headers: { 'Content-Type': 'application/json' }
        }).then(response => {
            setLoading(false);
            setUyari(true);
            setUyariAciklama("İşleminiz başarı ile gerçekleşti.")
            setUyariTip("success")
            getReceiptFiles(basvuruId)
        });
    }

    const uyariKapat = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setUyari(false);
    };
    const handleChangeStatus = ({ meta, file }, status) => {
        if (status == 'rejected_file_type') {
            setUyariAciklama("Sadece pdf dosya yükleyebilirsiniz. Lütfen dosya tipini kontrol ediniz!...");
            setUyari(true);
            setUyariTip("error");
        }

    }
    const handleSubmitImage = async (files, allFiles) => {
        var fileIsRequired = documentType.filter(i => i.ID == fileType)[0].ZORUNLU || false;
        if (files.length < props.dosyaAdet && fileIsRequired == 1) {
            setUyariAciklama("Yüklenen dosya adedi, seçilen kişi sayısından büyük ya da eşit olmadılıır. Lütfen kontrol ediniz!...")
            setUyari(true);
            setUyariTip("error");
            return;
        }
        setLoading(true)
        for (let i = 0; i < files.length; i++) {
            const fileMaterial = files[i].file;
            const metaMaterial = files[i].meta;
            let base64ResultMaterial = '';
            if (metaMaterial.type.indexOf('image') !== -1) {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                const image = new Image();
                image.src = URL.createObjectURL(fileMaterial);
                await new Promise((resolve, reject) => {
                  image.onload = () => {
                    const maxWidth = 1920;
                    const maxHeight = 1920;
                    let width = image.width;
                    let height = image.height;
                    if (width > maxWidth || height > maxHeight) {
                      if (width / height > maxWidth / maxHeight) {
                        width = maxWidth;
                        height = Math.round(maxWidth * (image.height / image.width));
                      } else {
                        height = maxHeight;
                        width = Math.round(maxHeight * (image.width / image.height));
                      }
                    }
                    canvas.width = width;
                    canvas.height = height;
                    ctx.drawImage(image, 0, 0, width, height);
                    base64ResultMaterial = canvas.toDataURL(metaMaterial.type, 1).split(',')[1];
                    resolve();
                  };
                  image.onerror = reject;
                });
              } else {
                base64ResultMaterial = await base64Reader(fileMaterial);
            }
            const data = {
                FileName: metaMaterial.name,
                FileType: metaMaterial.type,
                ReceiptNumber: basvuruId,
                FileData: base64ResultMaterial,
                TypeId: fileType,
                OnOnay: 1,
                OpenClose: openClose
            }
            uploadFiles(data)
            allFiles.forEach(f => f.remove())
            setLoading(false)
            setUploadFilePopUp(false)
            setUyariTip("success");
        }
    };



    async function base64Reader(file) {
        const result_base64 = await new Promise(resolve => {
            const fileReader = new FileReader();
            fileReader.onload = e => resolve(fileReader.result);
            fileReader.readAsDataURL(file);
        });
        return result_base64.split(',')[1] || '';
    }

    function clearForm() {
        setRows([])
        setSelectedUser('')
        setTransferTo([])
    }

    return (
        <>
            <Snackbar open={uyari} autoHideDuration={10000} onClose={uyariKapat}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}>
                <Alert onClose={uyariKapat} variant={uyariTip} message={uyariAciklama}>
                </Alert>
            </Snackbar>
            <Card>
                <CardHeader title="Belge Yükle" />
                <CardContent>
                    <Grid container spacing={2}>
                        <Typography sx={{ padding: '1%', width: '100%', fontWeight: 'bold' }} variant="subtitle1"></Typography>
                        <Grid item xs={6} md={6}>
                            <nav aria-label="secondary mailbox folders">
                                <TextField
                                    id="standard-basic"
                                    label="Ara"
                                    value={searchName}
                                    onChange={(event) => {
                                        setSearchName(event.target.value)
                                        handleUserClick([], -1)
                                    }
                                    } fullWidth size="small" />
                                <List style={{ height: 400, width: '100%', overflowY: 'auto' }}>
                                    {documentType.length > 0 && documentType?.filter(i => i.ACIKLAMA?.toLowerCase().includes(searchName.toLowerCase()))?.map((row, index) => (
                                        <ListItem key={index} disablepadding>
                                            <ListItemText
                                                primary={
                                                    <Typography>
                                                        {row.ACIKLAMA} <span style={{ color: 'red' }}> (*pdf)</span>
                                                    </Typography>
                                                }
                                            />
                                            <ListItemSecondaryAction>
                                                <IconButton
                                                    edge="end"
                                                    selected={selectedUser === index}
                                                    onClick={(event) => {
                                                        setUploadFilePopUp(true)
                                                        setFileType(row.ID)
                                                        handleUserClick()
                                                    }
                                                    }>
                                                    <Badge badgeContent={row.Count} color="success">
                                                        <AttachFileOutlinedIcon color="primary" />
                                                    </Badge>
                                                </IconButton>
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                    ))}
                                </List>
                            </nav>
                        </Grid>
                        <Grid item xs={6} md={6}>
                            <div style={{ height: 500, width: '100%' }}>
                                <DataGrid
                                    rows={rows}
                                    columns={columns}
                                    pageSize={8}
                                    rowsPerPageOptions={[8]}
                                    onSelectionChange={(selection) => {
                                        setSelectedTail(selection)
                                    }}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
            <Dialog
                open={uploadFilePopUp}
                onClose={() => setUploadFilePopUp(false)}
                aria-describedby="alert-dialog-slide-description"
                maxWidth="md"
                fullWidth
            >
                <DialogTitle sx={{ width: '100%' }} >Dosya Yükle</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} style={{ paddingTop: 20 }}>
                        <Grid item xs={12} md={12}>
                            <Dropzone
                                onChangeStatus={handleChangeStatus}
                                accept="application/pdf"
                                onSubmit={handleSubmitImage}
                                styles={{
                                    dropzone: { minHeight: 200, maxHeight: 250 }
                                }}
                                submitButtonContent="Yükle"
                                minSize={0}
                                maxSize={8072000}
                                inputContent={'Dosyayı sürükleyip bırakın ya da tıklayın'}
                                inputWithFilesContent={files => `${props.dosyaAdet - files.length} ekle`}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <DialogActions>
                        <IconButton
                            color="primary"
                            onClick={() => { setUploadFilePopUp(false); }}
                            aria-label="close"
                            component="span"
                            variant="contained"
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogActions>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default Overview;
